import * as React from 'react';

import {
  Stack,
  StackProps,
  Typography,
} from '@mui/material';
import { grey } from '@mui/material/colors';

interface PropertyStackProps extends StackProps {
  properties: Record<string, string | null | undefined>
}

function PropertyStack({ properties, ...stackProps }: PropertyStackProps) {
  return (
    <Stack {...stackProps}>
      {Object.keys(properties).map((key: string) => (
        <Stack direction="column" spacing={0} key={key}>
          <Typography variant="caption" sx={{ color: grey[500] }}>{key}</Typography>
          <Typography>{properties[key]}</Typography>
        </Stack>
      ))}
    </Stack>
  );
}

export default PropertyStack;
